module.exports = __webpack_public_path__ + "img/iot.3ddd1280.svg";